(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("manageExams", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/exams/manageExamsView.html",
            controller: ["examResource", "$sessionStorage", "$scope", "$state", "$translate", "DTOptionsBuilder", "DTColumnDefBuilder", ManageExamsCtrl],
            controllerAs: "vm"
        };
        function ManageExamsCtrl(examResource, $sessionStorage, $scope, $state, $translate, DTOptionsBuilder, DTColumnDefBuilder) {
            var vm = this;
            vm.dataLoaded = false;
            vm.dtInstance = {};
            vm.model = {
                exams: []
            };
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", false)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("order", [1, "asc"])
                .withPaginationType("full_numbers")
                .withOption("rowCallback", rowCallback)
                .withBootstrap();
            examResource.getManageExamsViewModel(function (model) {
                vm.model = model;
                vm.dataLoaded = true;
            });
            vm.rowClickHandler = rowClickHandler;
            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0).withOption("class", "control").withOption("sortable", false).withOption("targets", 0),
                DTColumnDefBuilder.newColumnDef(5).withOption("searchable", false).withOption("sortable", false),
                DTColumnDefBuilder.newColumnDef(6).withOption("searchable", false).withOption("type", "boolean"),
                DTColumnDefBuilder.newColumnDef(7).withOption("searchable", false).withOption("type", "date")
            ];
            if ($sessionStorage.manageExamsFilters) {
                vm.dtSearch = $sessionStorage.manageExamsFilters.search;
            }
            else {
                vm.dtSearch = "";
            }
            function rowClickHandler(row) {
                $state.go("main.learningItems.editExam", { number: row[1] });
            }
            function rowCallback(nRow, aData) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                $("td:not(.control)", nRow).bind("click", function () {
                    $scope.$apply(function () {
                        rowClickHandler(aData);
                    });
                });
                return nRow;
            }
            vm.goToQuestions = function (number) {
                $state.go("main.learningItems.manageExamQuestions", { number: number });
            };
            vm.search = function () {
                $sessionStorage.manageExamsFilters = { search: vm.dtSearch };
                vm.dtInstance.DataTable.search(vm.dtSearch).draw();
            };
        }
    });
}());
